import styled from 'styled-components';
import { Typography } from '../../atoms/typography/Typography';
import { spacing } from '../../atoms/spacing/spacing';
import { LIGHT_THEME } from '../../theming/constants';
import { ButtonTags } from './class-name-tags';
export const StyledButton = styled(Typography) `
  display: inline-block;
  text-decoration: none;

  .${ButtonTags.contentContainer} {
    display: flex;
    align-items: center;
    gap: ${spacing.spacing4};
    justify-content: center;
  }

  ${({ theme }) => theme.components.molecules.button.base}

  &.${ButtonTags.variant('primary')} {
    ${({ theme }) => theme.components.molecules.button.primary}
  }

  &.${ButtonTags.variant('secondary')} {
    ${({ theme }) => theme.components.molecules.button.secondary}
  }

  &.${ButtonTags.variant('ghost')} {
    ${({ theme }) => theme.components.molecules.button.ghost}
  }

  &.${ButtonTags.variant('negative')} {
    ${({ theme }) => theme.components.molecules.button.negative}
  }

  &.${ButtonTags.variant('text')} {
    ${({ theme }) => theme.components.molecules.button.text}
  }

  &.compact {
    ${({ theme }) => theme.components.molecules.button.compact}
  }
`;
StyledButton.defaultProps = {
    theme: LIGHT_THEME,
};
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;
//# sourceMappingURL=styled.js.map